var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStartSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99944 1.08337L6.45235 6.28237L0.666687 7.12133L4.8579 11.2188L3.85602 16.9167L8.99944 14.1747L14.1439 16.9167L13.1494 11.2188L17.3334 7.12133L11.5797 6.28237L8.99944 1.08337Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartSubscribe);
export default __webpack_public_path__ + "static/media/icon-start-subscribe.89407c177d676a76e9b6d4d9afe5afff.svg";
export { ForwardRef as ReactComponent };